// utils/quillBlots/inlineCommentEnd.js

import Quill from "quill";

const Embed = Quill.import("blots/embed");

class InlineCommentEndBlot extends Embed {
  static blotName = "inlineCommentEnd";
  static tagName = "span";
  static className = "ql-inline-comment-marker ql-inline-comment-marker--end";

  static create(value) {
    const node = super.create();

    const id = typeof value === "string" ? value : value?.id;
    if (id) node.setAttribute("data-comment-id", id);

    node.setAttribute("data-marker", "end");

    // Invisible, non-editable marker
    node.setAttribute("contenteditable", "false");
    node.setAttribute("aria-hidden", "true");
    node.style.display = "inline-block";
    node.style.width = "0";
    node.style.height = "0";
    node.style.overflow = "hidden";
    node.style.lineHeight = "0";

    return node;
  }

  static value(node) {
    return {
      id: node.getAttribute("data-comment-id") || "",
      marker: "end",
    };
  }
}

Quill.register(InlineCommentEndBlot);

export default InlineCommentEndBlot;
